export const BIG_GRID_ITEMS_IDX = [0, 5, 7, 9, 10, 13, 14, 18]

export const getCardTypeByIdx = (index: number, orientation) => {
  return BIG_GRID_ITEMS_IDX.find(idx => idx === index) >= 0 && orientation === "desktop" ? "medium" : "small";
}
